"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CORAL_LIGHT = exports.CORAL_MEDIUM = exports.CORAL = exports.TRUE_BLUE_LIGHT = exports.TRUE_BLUE_MEDIUM = exports.IDEAL_TEAL_LIGHT = exports.IDEAL_TEAL_MEDIUM = exports.PEACH_PINK_LIGHT = exports.PEACH_PINK_MEDIUM = exports.PEACH_PINK = exports.LAVENDER_LIGHT = exports.LAVENDER_MEDIUM = exports.LAVENDER = exports.GREEN_LIGHT = exports.GREEN_MEDIUM = exports.SALMON_LIGHTEST = exports.SALMON_LIGHT = exports.SALMON = exports.HONEY_GOLD_LIGHTEST = exports.HONEY_GOLD_LIGHT = exports.HONEY_GOLD = exports.CREAM_PINK_LIGHTEST = exports.CREAM_PINK_LIGHT = exports.CREAM_PINK = exports.RAINY_BLUE_LIGHTEST = exports.RAINY_BLUE_LIGHT = exports.RAINY_BLUE = exports.TWILIGHT_BLUE_LIGHTEST = exports.TWILIGHT_BLUE_LIGHT = exports.TWILIGHT_BLUE = exports.NORI_GREEN_LIGHT = exports.NORI_GREEN = exports.VALIDATION_RED = exports.VALIDATION_GREEN = exports.LIGHTEST_GREY = exports.LIGHTER_GREY = exports.GREY = exports.DARKER_GREY = exports.DARKEST_GREY = exports.AFRICAN_CORAL = exports.RED = exports.DARKEREST_TEAL = exports.DARKEST_TEAL = exports.DARKER_TEAL_2 = exports.DARKER_TEAL = exports.LIGHTER_TEAL = exports.PURPLE = exports.DARKER_GREEN = exports.LIGHTER_GREEN = exports.PALE_BLUE = exports.LIGHTER_BLUE = exports.BLUE = exports.DARKER_BLUE = exports.DARKEST_BLUE = exports.CLEAN_SLATE_GREY = exports.COOL_GREY = exports.MID_GREY = exports.DARK_GREY = exports.CHARCOAL = exports.SECONDARY_2 = exports.SECONDARY_ACTIVE = exports.SECONDARY_HOVER = exports.SECONDARY = exports.PRIMARY_ACTIVE = exports.PRIMARY_HOVER = exports.PRIMARY = exports.OPULENT_ORANGE = exports.COIN_YELLOW = exports.TRUE_BLUE = exports.IDEAL_TEAL_ACTIVE = exports.IDEAL_TEAL_HOVER = exports.IDEAL_TEAL = exports.GREEN_ACTIVE = exports.GREEN_HOVER = exports.GREEN = exports.WHITE = void 0;
var WHITE = '#ffffff';
exports.WHITE = WHITE;
var GREEN = '#6cc551';
exports.GREEN = GREEN;
var GREEN_HOVER = '#6ed14f';
exports.GREEN_HOVER = GREEN_HOVER;
var GREEN_ACTIVE = '#5eb243';
exports.GREEN_ACTIVE = GREEN_ACTIVE;
var IDEAL_TEAL = '#00accc';
exports.IDEAL_TEAL = IDEAL_TEAL;
var IDEAL_TEAL_HOVER = '#00b8d9';
exports.IDEAL_TEAL_HOVER = IDEAL_TEAL_HOVER;
var IDEAL_TEAL_ACTIVE = '#00a1ba';
exports.IDEAL_TEAL_ACTIVE = IDEAL_TEAL_ACTIVE;
var TRUE_BLUE = '#2b479e';
exports.TRUE_BLUE = TRUE_BLUE;
var COIN_YELLOW = '#FFCB05';
exports.COIN_YELLOW = COIN_YELLOW;
var OPULENT_ORANGE = '#FFA100';
exports.OPULENT_ORANGE = OPULENT_ORANGE;
var PRIMARY = GREEN;
exports.PRIMARY = PRIMARY;
var PRIMARY_HOVER = GREEN_HOVER;
exports.PRIMARY_HOVER = PRIMARY_HOVER;
var PRIMARY_ACTIVE = GREEN_ACTIVE;
exports.PRIMARY_ACTIVE = PRIMARY_ACTIVE;
var SECONDARY = IDEAL_TEAL;
exports.SECONDARY = SECONDARY;
var SECONDARY_HOVER = IDEAL_TEAL_HOVER;
exports.SECONDARY_HOVER = SECONDARY_HOVER;
var SECONDARY_ACTIVE = IDEAL_TEAL_ACTIVE;
exports.SECONDARY_ACTIVE = SECONDARY_ACTIVE;
var SECONDARY_2 = TRUE_BLUE; // greyscale

exports.SECONDARY_2 = SECONDARY_2;
var CHARCOAL = '#464646';
exports.CHARCOAL = CHARCOAL;
var DARK_GREY = '#747679';
exports.DARK_GREY = DARK_GREY;
var MID_GREY = '#afafaf';
exports.MID_GREY = MID_GREY;
var COOL_GREY = '#dcdcde';
exports.COOL_GREY = COOL_GREY;
var CLEAN_SLATE_GREY = '#f6f7f8'; // All fades of the same blue

exports.CLEAN_SLATE_GREY = CLEAN_SLATE_GREY;
var DARKEST_BLUE = '#0a74ad';
exports.DARKEST_BLUE = DARKEST_BLUE;
var DARKER_BLUE = '#0d88cd';
exports.DARKER_BLUE = DARKER_BLUE;
var BLUE = '#0e95e0';
exports.BLUE = BLUE;
var LIGHTER_BLUE = '#0f9eee';
exports.LIGHTER_BLUE = LIGHTER_BLUE;
var PALE_BLUE = '#a3d4e3';
exports.PALE_BLUE = PALE_BLUE;
var LIGHTER_GREEN = '#6fd162';
exports.LIGHTER_GREEN = LIGHTER_GREEN;
var DARKER_GREEN = '#519948';
exports.DARKER_GREEN = DARKER_GREEN;
var PURPLE = '#56508b';
exports.PURPLE = PURPLE;
var LIGHTER_TEAL = '#1bd1ad';
exports.LIGHTER_TEAL = LIGHTER_TEAL;
var DARKER_TEAL = '#06a19b';
exports.DARKER_TEAL = DARKER_TEAL;
var DARKER_TEAL_2 = '#14997e';
exports.DARKER_TEAL_2 = DARKER_TEAL_2;
var DARKEST_TEAL = '#048781';
exports.DARKEST_TEAL = DARKEST_TEAL;
var DARKEREST_TEAL = '#036e68';
exports.DARKEREST_TEAL = DARKEREST_TEAL;
var RED = '#ff7043';
exports.RED = RED;
var AFRICAN_CORAL = '#ff6e50';
exports.AFRICAN_CORAL = AFRICAN_CORAL;
var DARKEST_GREY = '#464646';
exports.DARKEST_GREY = DARKEST_GREY;
var DARKER_GREY = '#929292';
exports.DARKER_GREY = DARKER_GREY;
var GREY = '#bcbcbc';
exports.GREY = GREY;
var LIGHTER_GREY = '#dcdcdc';
exports.LIGHTER_GREY = LIGHTER_GREY;
var LIGHTEST_GREY = '#f8f8f8'; // Validation Colors

exports.LIGHTEST_GREY = LIGHTEST_GREY;
var VALIDATION_GREEN = PRIMARY;
exports.VALIDATION_GREEN = VALIDATION_GREEN;
var VALIDATION_RED = RED; // IPX Colors

exports.VALIDATION_RED = VALIDATION_RED;
var NORI_GREEN = '#64b498';
exports.NORI_GREEN = NORI_GREEN;
var NORI_GREEN_LIGHT = '#eff7f4';
exports.NORI_GREEN_LIGHT = NORI_GREEN_LIGHT;
var TWILIGHT_BLUE = '#004878';
exports.TWILIGHT_BLUE = TWILIGHT_BLUE;
var TWILIGHT_BLUE_LIGHT = '#ccdae4';
exports.TWILIGHT_BLUE_LIGHT = TWILIGHT_BLUE_LIGHT;
var TWILIGHT_BLUE_LIGHTEST = '#e5ecf1';
exports.TWILIGHT_BLUE_LIGHTEST = TWILIGHT_BLUE_LIGHTEST;
var RAINY_BLUE = '#95d5ff';
exports.RAINY_BLUE = RAINY_BLUE;
var RAINY_BLUE_LIGHT = '#e1f3ff';
exports.RAINY_BLUE_LIGHT = RAINY_BLUE_LIGHT;
var RAINY_BLUE_LIGHTEST = '#f4faff';
exports.RAINY_BLUE_LIGHTEST = RAINY_BLUE_LIGHTEST;
var CREAM_PINK = '#ffc2bc';
exports.CREAM_PINK = CREAM_PINK;
var CREAM_PINK_LIGHT = '#fff2f1';
exports.CREAM_PINK_LIGHT = CREAM_PINK_LIGHT;
var CREAM_PINK_LIGHTEST = '#fff8f8';
exports.CREAM_PINK_LIGHTEST = CREAM_PINK_LIGHTEST;
var HONEY_GOLD = '#ffb809';
exports.HONEY_GOLD = HONEY_GOLD;
var HONEY_GOLD_LIGHT = '#fff0cd';
exports.HONEY_GOLD_LIGHT = HONEY_GOLD_LIGHT;
var HONEY_GOLD_LIGHTEST = '#fff7e6';
exports.HONEY_GOLD_LIGHTEST = HONEY_GOLD_LIGHTEST;
var SALMON = '#ffaf83';
exports.SALMON = SALMON;
var SALMON_LIGHT = '#ffefe6';
exports.SALMON_LIGHT = SALMON_LIGHT;
var SALMON_LIGHTEST = '#fff7f2';
exports.SALMON_LIGHTEST = SALMON_LIGHTEST;
var GREEN_MEDIUM = '#def4db';
exports.GREEN_MEDIUM = GREEN_MEDIUM;
var GREEN_LIGHT = '#e9f9eb'; // deprecated colors that should not be used (but are here for backwards compatibility)

exports.GREEN_LIGHT = GREEN_LIGHT;
var LAVENDER = '#ad94fa';
exports.LAVENDER = LAVENDER;
var LAVENDER_MEDIUM = '#eee4ff';
exports.LAVENDER_MEDIUM = LAVENDER_MEDIUM;
var LAVENDER_LIGHT = '#f8f4ff';
exports.LAVENDER_LIGHT = LAVENDER_LIGHT;
var PEACH_PINK = '#ff83a7';
exports.PEACH_PINK = PEACH_PINK;
var PEACH_PINK_MEDIUM = '#ffe4ee';
exports.PEACH_PINK_MEDIUM = PEACH_PINK_MEDIUM;
var PEACH_PINK_LIGHT = '#fff0f6';
exports.PEACH_PINK_LIGHT = PEACH_PINK_LIGHT;
var IDEAL_TEAL_MEDIUM = '#c5eff6';
exports.IDEAL_TEAL_MEDIUM = IDEAL_TEAL_MEDIUM;
var IDEAL_TEAL_LIGHT = '#e2f7f9';
exports.IDEAL_TEAL_LIGHT = IDEAL_TEAL_LIGHT;
var TRUE_BLUE_MEDIUM = '#d4daed';
exports.TRUE_BLUE_MEDIUM = TRUE_BLUE_MEDIUM;
var TRUE_BLUE_LIGHT = '#e9ecf6';
exports.TRUE_BLUE_LIGHT = TRUE_BLUE_LIGHT;
var CORAL = '#ff634b';
exports.CORAL = CORAL;
var CORAL_MEDIUM = '#ffdcda';
exports.CORAL_MEDIUM = CORAL_MEDIUM;
var CORAL_LIGHT = '#ffedec';
exports.CORAL_LIGHT = CORAL_LIGHT;